export default "dist/images/components-columns-width-control-4-2.96599c1.png";